import { Box, Text } from '@chakra-ui/react';
import { ReactComponent as CopyIcon } from 'assets/copy-icon.svg';
import { ReactComponent as PlusIcon } from 'assets/plus-icon.svg';

interface AddressValueProps {
  address: string;
  onCopy: (text: string) => void;
  onSave: (address: string) => void;
}

const AddressValue = ({ address, onCopy, onSave }: AddressValueProps) => (
  <Box display="flex" alignItems="center" gap={2} justifyContent="flex-start">
    <Text size="sm" variant="bodyNormal" wordBreak="break-all" textAlign="left">
      {address}
    </Text>
    <CopyIcon
      cursor="pointer"
      style={{ flexShrink: 0 }}
      onClick={(e: React.MouseEvent) => {
        e.stopPropagation();
        onCopy(address);
      }}
    />
    <Box
      as="button"
      title="Save to Address Book"
      cursor="pointer"
      fontSize="14px"
      flexShrink={0}
      onClick={(e: React.MouseEvent) => {
        e.stopPropagation();
        onSave(address);
      }}
    >
      <PlusIcon />
    </Box>
  </Box>
);

export default AddressValue;
